module.exports = __webpack_public_path__ + "img/search-alternate.78dcc19b.svg";